var map = {
	"./sticker_1.svg": "d8c3",
	"./sticker_2.svg": "5794",
	"./sticker_3.svg": "5ad8",
	"./sticker_4.svg": "da83",
	"./sticker_5.svg": "70a2",
	"./sticker_6.svg": "75ae",
	"./sticker_7.svg": "4726",
	"./sticker_8.svg": "bd00",
	"./sticker_9.svg": "2e08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2041";